__webpack_require__.p = "https://eu-cdn.shipsy.io/crm-assets/";